import type { ProgramDialInInformation } from 'models';
import { Button, Dropdown, Icon } from 'ui';
import { EventDialInDropdownItem } from './event-dial-in-dropdown-item';

type DialInData = { href: string } & ProgramDialInInformation;

type P = {
  block?: boolean;
  dialInData: DialInData;
  size: 'large' | 'small';
};

const EventDialInButton = ({ block, dialInData, size }: P) => {
  const menu = {
    items: [
      {
        key: 'dial-in',
        label: <EventDialInDropdownItem dialInData={dialInData} />,
      },
    ],
  };

  return (
    <Dropdown menu={menu} trigger={['click']}>
      <Button
        block={block}
        icon={<Icon icon="phone-line" />}
        onClick={(event) => {
          event.preventDefault();
        }}
        size={size}
      >
        Dial-in
        <Icon icon="down-line" />
      </Button>
    </Dropdown>
  );
};

export default EventDialInButton;
